import { ReactElement } from 'react'

import { BoxProps } from 'designSystem/components/PDSBox/PDSBox'
import INTERNALxDiv from 'designSystem/components/internal/elements/INTERNALxDiv'

type Props = BoxProps

export default function PDSFlexBox({ testId, ...props }: Props): ReactElement {
  return <INTERNALxDiv data-testid={testId} display="flex" {...props} />
}
